import { Link } from 'react-router-dom';

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-6">
        <Link to="/" className="inline-flex items-center gap-2.5 font-mono text-xl font-bold">
          <img
            src="/images/app-icon.png"
            alt=""
            aria-hidden="true"
            width={36}
            height={36}
            className="h-9 w-9 rounded-[22%]"
          />
          notetime
        </Link>
        <nav aria-label="Site">
          <Link
            to="/features"
            className="inline-flex min-h-[44px] items-center font-mono text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            features
          </Link>
        </nav>
      </div>
    </header>
  );
}
